import { IDataGenericText } from "@app/interfaces/idata-grouped";

export const APPLICATION_STAGE: Array<IDataGenericText> = [
    { id: 1, text: 'Postulantes' },
    { id: 2, text: 'Descartados' },
    { id: 3, text: 'Preseleccionados' },
    { id: 4, text: 'A entrevistar' },
    { id: 5, text: 'Contratados' },
    { id: 6, text: 'Evaluación Psicolaboral' },
]
